<template>
  <div class="c-pdf-preview">
    <object
      v-if="fileSrc && !isIE"
      :data="fileSrc"
      type="application/pdf"
      width="100%"
      height="800px"
    >
      <p>
        Your browser can not display this file. Please click the 'download'
        button above to download the file to your computer.
      </p>
    </object>
    <embed
      v-if="fileSrc && isIE"
      type="application/pdf"
      :src="fileSrc"
      width="100%"
      height="800px"
    />
  </div>
</template>

<script>
import filesApi from "@/api/files";

export default {
  name: "pdf-preview",

  props: ["fileId"],

  data() {
    return {
      fileSrc: null,
      isIE: false,
      fileLink: null,
    };
  },

  mounted() {
    this.getFile();
  },

  methods: {
    getFile() {
      const vm = this;
      filesApi.read(this.fileId).then((file) => {
        this.fileLink = file.link;

        filesApi.readLink(file.link).then((response) => {
          this.setFileData(response.data);
        });
      });
    },

    downloadFile() {
      this.$store.dispatch("files/download", this.fileLink);
      this.showWarning();
    },

    setFileData(blob) {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        this.isIE = true;
      }
      this.fileSrc = URL.createObjectURL(blob);
    },
  },
};
</script>

<style lang="scss">
.c-pdf-preview {
  &__document {
    background: $colour-nhs-white;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.11);
  }
}
</style>
